import React from 'react';
import Skeleton from 'src/Admin/components/common/skeleton';

const Lists = ({ data, selectChangeHandler, searchString }) => {
  const onChangeHandler = (e) => {
    selectChangeHandler(e);
  };

  return (
    <div className="blob-lists">
      {data ? (
        data
          .filter((d) => {
            if (!searchString) return true;
            if (d.RoleName !== '') {
              if (
                d.RoleName.toLowerCase().includes(searchString.toLowerCase())
              ) {
                return true;
              }
            }
          })
          .map((item, index) => {
            return (
              <div key={index}>
                <div className="blob-list-item-border">
                  <div className="d-flex broker-list-item">
                    <div className="d-flex">
                      <div className="d-flex mb-3">
                        <input
                          type="checkbox"
                          id={item.RoleName}
                          name={item.RoleName}
                          className="p-0 mt-auto mb-auto"
                          onChange={(e) => onChangeHandler(e)}
                          checked={item?.isChecked || false}
                        />
                      </div>
                      <div>
                        <div>
                          <span className="blob-item-name">
                            {item.RoleName}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
      ) : (
        <Skeleton count={20} height={30} />
      )}
    </div>
  );
};

export default Lists;
